/**
 * caseConverter.js
 *
 * Converts between camelCase (frontend) and snake_case (Phoenix backend).
 *
 * Strategy:
 *   - outgoing requests: camelCase → snake_case (toSnake)
 *   - incoming responses: snake_case → camelCase (toCamel)
 *
 * This lets all existing pages keep their camelCase field references
 * while the Phoenix API receives/returns snake_case cleanly.
 */

const toSnakeCase = (str) =>
  str.replace(/([A-Z])/g, (c) => `_${c.toLowerCase()}`);

const toCamelCase = (str) =>
  str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

const isPlainObject = (val) =>
  val !== null &&
  typeof val === "object" &&
  !Array.isArray(val) &&
  !(val instanceof Date);

/**
 * Deep-convert all object keys to snake_case.
 * Use before sending data to Phoenix.
 */
export const toSnake = (data) => {
  if (Array.isArray(data)) return data.map(toSnake);
  if (!isPlainObject(data)) return data;
  return Object.fromEntries(
    Object.entries(data).map(([k, v]) => [toSnakeCase(k), toSnake(v)]),
  );
};

/**
 * Deep-convert all object keys to camelCase.
 * Use after receiving data from Phoenix.
 */
export const toCamel = (data) => {
  if (Array.isArray(data)) return data.map(toCamel);
  if (!isPlainObject(data)) return data;
  return Object.fromEntries(
    Object.entries(data).map(([k, v]) => [toCamelCase(k), toCamel(v)]),
  );
};
